import { useEffect, useState } from 'react';
import { FunctionComponent } from 'react';
import './contact-form.scss';
import { produce } from 'immer';
import { GetLanguageLabel } from '../tools';
import DIV from '../html-tags/div';
import LABEL from '../html-tags/label';

export type Props = { source: string; textfieldLabel: string; textfieldPlaceholder: string };

const ContactForm: FunctionComponent<Props> = (props) => {
  const [caseCreated, setCaseCreated] = useState<boolean>(false);
  const [payloadData, setPayloadData] = useState<{
    accountName: string;
    firstName: string;
    lastName: string;
    addressCountry: string;
    emailAddress: string;
    description: string;
    user1: string;
    dataSource: string;
  }>({
    accountName: '',
    firstName: '',
    lastName: '',
    addressCountry: '',
    emailAddress: '',
    description: '',
    user1: '',
    dataSource: '',
  });

  // Define the API URL and the endpoint for creating a case
  const apiUrl = 'https://crm.2x4.de/api/v1/LeadCapture/bb21084369ff6aedadfd0a9088c6e2f0';

  // Function to create a case
  // ----------------------------------------------------------------
  async function createCase(data: any) {
    // ----------------------------------------------------------------
    //console.log(data);

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      } else {
        setCaseCreated(true);
        setTimeout(() => {
          window.location.href = '/de/contact-success';
        }, 1);
      }

      //const responseData = await response.json();
      //console.log('Case created successfully:', responseData);
    } catch (error) {
      console.error('Error creating case:', error);
    }
  }

  useEffect(() => {
    setPayloadData(
      produce(payloadData, (update) => {
        update.dataSource = props.source;
      })
    );
  }, [payloadData, props.source]);

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <div className="form">
      {!caseCreated && (
        <>
          <div className="form-line">
            <DIV language="de" className="form-label">
              Firma
            </DIV>
            <DIV language="en" className="form-label">
              Company
            </DIV>
            <div className="form-input">
              <input
                className="full-width"
                type="text"
                placeholder={GetLanguageLabel([
                  { language: 'de', label: 'Name der Firma oder Institution' },
                  { language: 'en', label: 'Company Name' },
                ])}
                value={payloadData.accountName}
                onChange={(e) => {
                  setPayloadData(
                    produce(payloadData, (update) => {
                      update.accountName = e.currentTarget.value;
                    })
                  );
                }}
              ></input>
            </div>
          </div>
          <div className="form-line">
            <DIV language="de" className="form-label">
              Dein Name
            </DIV>
            <DIV language="en" className="form-label">
              Your Name
            </DIV>
            <div className="form-input">
              <input
                className="half-width"
                type="text"
                placeholder={GetLanguageLabel([
                  { language: 'de', label: 'Vorname' },
                  { language: 'en', label: 'First Name' },
                ])}
                value={payloadData.firstName}
                onChange={(e) => {
                  setPayloadData(
                    produce(payloadData, (update) => {
                      update.firstName = e.currentTarget.value;
                    })
                  );
                }}
              ></input>
              <input
                className="half-width"
                type="text"
                placeholder={GetLanguageLabel([
                  { language: 'de', label: 'Nachname' },
                  { language: 'en', label: 'Last Name' },
                ])}
                value={payloadData.lastName}
                onChange={(e) => {
                  setPayloadData(
                    produce(payloadData, (update) => {
                      update.lastName = e.currentTarget.value;
                    })
                  );
                }}
              ></input>
            </div>
          </div>
          <div className="form-line">
            <DIV language="de" className="form-label">
              Land
            </DIV>
            <DIV language="en" className="form-label">
              Country
            </DIV>
            <div className="form-input">
              <input
                className="full-width"
                type="text"
                placeholder={GetLanguageLabel([
                  { language: 'de', label: 'Land' },
                  { language: 'en', label: 'Country' },
                ])}
                value={payloadData.addressCountry}
                onChange={(e) => {
                  setPayloadData(
                    produce(payloadData, (update) => {
                      update.addressCountry = e.currentTarget.value;
                    })
                  );
                }}
              ></input>
            </div>
          </div>
          <div className="form-line">
            <DIV language="en" className="form-label">
              Email
            </DIV>
            <DIV language="de" className="form-label">
              E-Mail
            </DIV>
            <div className="form-input">
              <input
                className="full-width"
                type="text"
                placeholder={GetLanguageLabel([
                  { language: 'de', label: 'Deine berufliche E-Mail Adresse' },
                  { language: 'en', label: 'Your Company Email' },
                ])}
                value={payloadData.emailAddress}
                onChange={(e) => {
                  setPayloadData(
                    produce(payloadData, (update) => {
                      update.emailAddress = e.currentTarget.value;
                    })
                  );
                }}
              ></input>
            </div>
          </div>
          <div className="form-line">
            <div className="form-label">{props.textfieldLabel}</div>
            <div className="form-input">
              <textarea
                className="full-width"
                placeholder={props.textfieldPlaceholder}
                value={payloadData.description}
                onChange={(e) => {
                  setPayloadData(
                    produce(payloadData, (update) => {
                      update.description = e.currentTarget.value;
                    })
                  );
                }}
              />
            </div>
          </div>
          <div className="form-line">
            <div className="form-label"></div>
            <div className="form-input form-privacy">
              <input
                id="privacy"
                type="checkbox"
                checked={payloadData.user1 !== ''}
                onChange={(e) => {
                  setPayloadData(
                    produce(payloadData, (update) => {
                      update.user1 = e.currentTarget.checked
                        ? 'Policy Accepted: ' + new Date()
                        : '';
                    })
                  );
                }}
              ></input>
              <LABEL language="de" htmlFor="privacy">
                Ich stimme zu, daß meine personenbezogenen Daten gemäß der{' '}
                <a href="/de/privacy" target="_blank">
                  Datenschutzerklärung
                </a>{' '}
                erhoben und verarbeitet werden.
              </LABEL>
              <LABEL language="en" htmlFor="privacy">
                I accept that the data above will be processed and stored according to the
                SurveyTester{' '}
                <a href="/en/privacy" target="_blank">
                  Privacy Policy
                </a>
              </LABEL>
            </div>
          </div>
          <div className="form-line">
            <div className="form-label"></div>
            <div className="form-send">
              <input
                type="button"
                value={GetLanguageLabel([
                  { language: 'de', label: 'Nachricht senden' },
                  { language: 'en', label: 'Send Message' },
                ])}
                onClick={() => {
                  createCase(payloadData);
                }}
                disabled={
                  !(
                    payloadData.accountName &&
                    payloadData.addressCountry &&
                    payloadData.description &&
                    payloadData.emailAddress &&
                    payloadData.firstName &&
                    payloadData.lastName &&
                    payloadData.user1
                  )
                }
              ></input>
            </div>
          </div>
        </>
      )}
      {
        // ===============================================================================
        caseCreated && (
          <div className="confirmation">
            <div className="confirmation-text">
              <h4>Vielen Dank für deine Nachricht</h4>
              <p>
                Wir sind schon ganz gespannt darauf, wie wir dir helfen können.
                <br />
                Einer unserer Experten wird sich in Kürze bei dir melden.
              </p>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default ContactForm;
